import { render, staticRenderFns } from "./ModalMostrarPagoUniversidad.vue?vue&type=template&id=ddda20da&scoped=true"
import script from "./ModalMostrarPagoUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalMostrarPagoUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ModalMostrarPagoUniversidad.vue?vue&type=style&index=0&id=ddda20da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddda20da",
  null
  
)

export default component.exports